/**
 * トップページからの流入はフェードインする
 */

const init = () => {
  const $fadeInWall = document.querySelector("#fade_in_wall");
  if (!$fadeInWall) return;

  gsap.to($fadeInWall, {
    opacity: 0,
    ease: "power0",
    duration: 1,
    onComplete: () => {
      $fadeInWall.remove();
    },
  });
};

export { init };
